<div class="container">
    <div class="row">
        <div class="card" style="width:100%;">
            <div class="card-body">
                <p class="intro-text">{{ 'APPEALS_DASHBOARD_INTRO' | globalTranslate }}</p>
                <section class="appeal-section" [attr.aria-labelledby]="'eligibility-appeals-heading'">
                    <h2 id="eligibility-appeals-heading" class="section-header">{{ 'ELIGIBILITY_APPEALS_TITLE' | globalTranslate }}</h2>
                    <hr class="header-underline" [attr.aria-hidden]="true">
                    <p class="section-description">{{ 'ELIGIBILITY_APPEALS_DESC' | globalTranslate }}</p>
                    <p class="section-info">{{ 'YOU_HAVE_RIGHT_TO_APPEAL_IF' | globalTranslate }}</p>
                    <ul class="appeal-reasons">
                        <li>{{ 'ELIGIBILITY_REASON_1' | globalTranslate }}</li>
                        <li>{{ 'ELIGIBILITY_REASON_2' | globalTranslate }}</li>
                        <li>{{ 'ELIGIBILITY_REASON_3' | globalTranslate }}</li>
                        <li>{{ 'ELIGIBILITY_REASON_4' | globalTranslate }}</li>
                    </ul>
                    <p class="click-text" [innerHTML]="'ELIGIBILITY_CLICK_TO_FILE' | globalTranslate"></p>
                    <p class="more-info" [innerHTML]="'FOR_MORE_INFO_ABOUT_ELIGIBILITY' | globalTranslate"></p>
                    <div class="button-container mt-4 mb-5">
                        <button type="button" class="btn btn-primary appeal-button" (click)="goToEligibilityAppeals()">{{ 'MY_ELIGIBILITY_APPEALS_BUTTON' | globalTranslate }}</button>
                    </div>
                </section>
                <section class="appeal-section" [attr.aria-labelledby]="'medical-appeals-heading'">
                    <h2 id="medical-appeals-heading" class="section-header">{{ 'MEDICAL_APPEAL_REQUESTS_TITLE' | globalTranslate }}</h2>
                    <hr class="header-underline" [attr.aria-hidden]="true">
                    <p class="section-description">{{ 'MEDICAL_APPEAL_REQUESTS_DESC' | globalTranslate }}</p>
                    <p class="section-info">{{ 'YOU_HAVE_RIGHT_TO_APPEAL_IF' | globalTranslate }}</p>
                    <ul class="appeal-reasons">
                        <li>{{ 'MEDICAL_REASON_1' | globalTranslate }}</li>
                        <li>{{ 'MEDICAL_REASON_2' | globalTranslate }}</li>
                        <li>{{ 'MEDICAL_REASON_3' | globalTranslate }}</li>
                        <li>{{ 'MEDICAL_REASON_4' | globalTranslate }}</li>
                        <li>{{ 'MEDICAL_REASON_5' | globalTranslate }}</li>
                    </ul>
                    <p class="note-text" [innerHTML]="'MEDICAL_APPEAL_60_DAY_NOTE' | globalTranslate"></p>
                    <p class="click-text" [innerHTML]="'MEDICAL_CLICK_TO_FILE' | globalTranslate"></p>
                    <p class="more-info" [innerHTML]="'FOR_MORE_INFO_ABOUT_MEDICAL' | globalTranslate"></p>
                    <div class="button-container mt-4 mb-3">
                        <div class="p-1 file_appeal">
                            <button (click)="startMedicalAppeal('MEDICAL_APPEAL')" class="btn btn-secondary btn-search">{{'FILE_MEDICAL_APL_BTN_TEXT' | globalTranslate}}</button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>